import styled from "styled-components";

export const Redbutton = styled.button`
  background-color: #c32728;
  border-radius: 32px;
  font-family: Poppins;
  font-size: 18px;
  font-weight: 400;
  line-height: 27px;
  text-align: center;
  color: #ffffff;
  padding: 10px 20px;
  border:1px solid transparent;
  cursor: pointer;
  width: 100%;
`;

export const CreateButton = styled.button`
  border-radius: 10px;
  background: #c32728;
  font-family: Poppins;
  font-size: 14px;
  font-weight: 500;
  line-height: 21px;
  text-align: left;
  color: #ffffff;
  padding: 10px 20px;
  cursor: pointer;
  border: 1px solid transparent;
 
`;

export const ViewMoreButton = styled.button`
  border: 1px solid #777777;
  font-family: Poppins;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  text-align: center;
  color: #777777;
  padding: 0px 20px;
  cursor: pointer;
  background-color: transparent;
  border-radius:8px;
  height: 40px;
`;

export const GreyBorderButton = styled.button`
border: 1px solid #777777;
border-radius: 30px;
font-family: Poppins;
font-size: 16px;
font-weight: 500;
line-height: 24px;
text-align: left;
color: #333333;
padding: 10px 20px;
cursor: pointer;
background-color: transparent;
`;

export const RedBackgroundButton = styled.button`
background: #C32728;
font-family: Poppins;
font-size: 16px;
font-weight: 500;
line-height: 24px;
/* text-align: left; */
color: #FFFFFF;
padding: 10px 20px;
cursor: pointer;
border-radius: 30px;
border: 1px solid transparent;
`;

export const GreyBackgroundButton = styled.button`
background-color:#333333;
font-family:Poppins;
font-size:16px;
font-weight:500;
line-height:24px;
text-align:left;
color:#FFFFFF;
padding:10px 20px;
cursor: pointer;
border-radius: 30px;
border: 1px solid transparent
`;

export const GreylessradiusButton = styled.button`
background-color:#333333;
font-family:Poppins;
font-size:16px;
font-weight:500;
line-height:24px;
text-align:left;
color:#FFFFFF;
padding:10px 20px;
cursor: pointer;
border-radius: 10px;
border: 1px solid transparent
`;

export const GreyfilterButton = styled.button`
border-radius:8px;
padding:0px 20px;
border: 0.5px solid #CCCCCC;
font-family: Poppins;
font-size: 14px;
font-weight: 400;
line-height: 24px;
text-align: left;
color:#777777;
background-color: transparent;

`;

export const RedBorderButton = styled.button`
border: 1px solid #C32728;
font-family: Poppins;
font-size: 13px;
font-weight: 500;
line-height: 24px;
text-align: left;
padding:7px 20px;
color:#C32728;
border-radius:8px;
cursor: pointer;
background-color: transparent;

`


export const GreenBorderButton = styled.button`
border: 1px solid #27c36d;
font-family: Poppins;
font-size: 13px;
font-weight: 500;
line-height: 24px;
text-align: left;
padding:7px 20px;
color:#C32728;
border-radius:8px;
cursor: pointer;
background-color: transparent;

`
export const RedBordButton = styled.button`
border: 1px solid #C32728;
font-family: Poppins;
font-size: 12px;
font-weight: 500;
line-height: 18px;
padding:10px 15px;
cursor: pointer;
color:#C32728;
background-color: transparent;
border-radius: 8px;
`

export const GreenBackgroundButton = styled.button`
background: #00AC4F;
font-family: Poppins;
font-size: 14.4px;
font-weight: 500;
line-height: 21.6px;
text-align: left;
color: #FAFAFA;
padding:10px 20px;
cursor: pointer;
border-radius: 50px;
border:1px solid transparent;
`
